import { gql } from '@apollo/client';
import { AGENT_PROFILE_FRAGMENT } from './agentProfileFragment';
import { AGENT_ACTIVITIES_FRAGMENT } from './agentActivitiesFragment';

export const SESSION_AGENT_FRAGMENT = gql`
  fragment AgentFragment on Agent {
    id
    email
    firstName
    lastName
    phone
    isAdmin
    isPrincipalAgent
    roles
    userRole
    agencyId
    fullName
    createdAt
    agentProfile {
      ...AgentProfileFragment
    }
    activities {
      ...AgentActivitiesFragment
    }
  }
  ${AGENT_ACTIVITIES_FRAGMENT}
  ${AGENT_PROFILE_FRAGMENT}
`;

export const AGENT_FRAGMENT = gql`
  fragment AgentFragment on Agent {
    id
    email
    firstName
    lastName
    phone
    isAdmin
    isPrincipalAgent
    roles
    userRole
    agencyId
    fullName
    createdAt
    agentProfile {
      ...AgentProfileFragment
    }
  }
  ${AGENT_PROFILE_FRAGMENT}
`;
